import React, { useState , useEffect } from 'react'
import { Badge, Container, Slide, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { Check } from '@mui/icons-material'

export const Stepper = ({ steps, sx, infoUser: externalInfoUser }) => {
    const [internalInfoUser, setInternalInfoUser] = useState();
    const infoUser = externalInfoUser?.role ? externalInfoUser : internalInfoUser;
    const [step, setStep] = useState(0);
    const [publishType, setPublishType] = useState();
    const [selectedIncome, setSelectedIncome] = useState(0);
    const [files, setFiles] = useState([]);
    const [courseDetail, setCourseDetail] = useState({
        img: '',
        video: '',
        name: '',
        priceIE : '',
        time: '',
        category: '',
        offPercent: '',
        description: '',
        isCourseHasCertificate: false,
    })

    const publishTypesHandler = (props) => {
        setPublishType(props.name)
    }

    const selectedIncomeHandler = (props) => {
        setSelectedIncome(props)
    }

    const generateTextColor = (targetStep) => {
        if (targetStep == step) return 'CaptionText'
        if (targetStep > step) return 'grey.500'
        if (targetStep < step) return 'primary.main'
    }



    return (
        <Box sx={{ flexDirection: 'column', display: 'flex', width: '100%', alignItems: 'center', ...sx }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', px: { xs: 2.5, lg: '25%' }, py: 2, width: '100%', alignItems: 'flex-start', background: '#fff', boxSizing: 'border-box' }}>

                {steps?.map((targetStep, index) => {

                    const Icon = targetStep.icon

                    const isStepPassed = step > index
                    const isStepActive = step == index

                    return <>
                        <Box sx={{
                            display: { xs: step - index <= 2 ? 'flex' : 'none', lg: 'flex' },
                            flexDirection: 'column',
                            alignItems: 'center',
                            mx: 0.5,
                        }}>
                            <Box sx={{
                                backgroundColor: isStepPassed || isStepActive ? 'primary.main' : 'grey.200',
                                borderRadius: '50%',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                height: '45px',
                                width: '45px',
                                justifyContent: 'center',
                                my: 1.5,
                                transition: 'all 0.2s ease',
                                zIndex:0
                            }}>
                                <Badge badgeContent={isStepPassed ? <Box sx={{ width: '15px', height: '15px', borderRadius: '50%', border: '2px solid white' }}>
                                    <Check sx={{ height: 'unset', width: 'unset' }} /></Box> : null} color='primary' anchorOrigin={{
                                        horizontal: 'left',
                                        vertical: 'bottom'
                                    }}
                                    componentsProps={{ badge: { style: { padding: 0, marginRight: '-8px', overflow: 'hidden' } } }}
                                >
                                    <Icon sx={{ color: isStepPassed || isStepActive ? '#fff' : 'black' }} />
                                </Badge>
                            </Box>
                            <Typography fontSize={13} color={generateTextColor(index)}>{targetStep.title}</Typography>
                        </Box>


                        {index + 1 < steps.length && <Box sx={{ backgroundColor: isStepPassed ? 'primary.main' : 'grey.300', borderRadius: 1, height: '2px', flex: 1, mt: '35px', display: { xs: step - index <= 3 ? 'flex' : 'none', lg: 'flex' }, }}>

                        </Box>}

                    </>
                }
                )}
            </Box>
            <Container maxWidth='xl'>

                {steps?.map((targetStep, index) => {

                    const StepContentComponent = targetStep.content

                    return <Slide direction="left" in={index == step} mountOnEnter unmountOnExit key={index}>
                        {StepContentComponent({ setStep: setStep, publishTypesHandler, selectedIncomeHandler, price: selectedIncome ,courseDetail , setCourseDetail , seInfoUser: setInternalInfoUser , infoUser , publishType, files, setFiles })}
                    </Slide>

                })}
            </Container>

        </Box >
    )
}
